export default "__VITE_ASSET__CK$O69Qu__"